import * as Yup from 'yup';
import { useTranslation } from 'react-i18next';
import { Form } from '@/components';
import { AddArticleArgs, UpdateArticleArgs } from '@/redux/articles';
import { useField } from 'formik';

interface Props {
  id?: string;
  initialValue?: AddArticleArgs;
  onSubmit: (value: AddArticleArgs) => any;
}

const schema = Yup.object().shape({
  title: Yup.string().required(),
  shortDescription: Yup.string().nullable().max(2000),
  description: Yup.string().required(),
  attachmentIds: Yup.array()
    .of(Yup.string().nullable().required())
    .nullable()
    .defined(),
});

const DEFAULT_VALUE: AddArticleArgs | UpdateArticleArgs = {
  title: '',
  shortDescription: null,
  description: '',
  attachmentIds: [],
};

export function ArticleEditPanel(props: Props) {
  const { initialValue, onSubmit, id } = props;
  const { t } = useTranslation();

  const value = initialValue ?? DEFAULT_VALUE;

  return (
    <Form.Formik<AddArticleArgs | UpdateArticleArgs>
      uid="article-details"
      i18n="articles.details"
      initialValues={{ ...value, attachmentIds: [] }}
      validationSchema={schema}
      onSubmit={onSubmit}
    >
      <Form.Input
        name="title"
        placeholder={t('articles.placeholder.title')}
        required
      />
      <Form.TextArea name="shortDescription" />
      <div>
        <FormRichText
          name="description"
          attachmentName="attachmentIds"
          ownerId={id}
        />
      </div>
    </Form.Formik>
  );
}

function FormRichText({
  name,
  attachmentName,
  ownerId,
}: {
  name: string;
  attachmentName: string;
  ownerId?: string;
}) {
  const [, , { setValue }] = useField(attachmentName);
  return (
    <Form.RichTextEditor
      name={name}
      required
      setAttachmentIds={setValue}
      ownerId={ownerId}
      ownerType="Article"
    />
  );
}
